/**
 * Consulta de CEP no ViaCEP. É um serviço público e gratuito, sem chave.
 *
 * Falha em silêncio de propósito: preencher sozinho é conveniência, não
 * requisito. Se o serviço estiver fora do ar, o lojista digita os campos — o que
 * não pode acontecer é o salvamento das configurações travar por causa de uma
 * consulta auxiliar.
 *
 * Cópia do arquivo de mesmo nome no cardápio do cliente. Os dois repositórios
 * publicam separado e não compartilham pacote; unificar exigiria criar um, o que
 * é decisão maior do que este arquivo de trinta linhas justifica.
 */
export async function buscarCep(cep) {
  const digitos = (cep || '').replace(/\D/g, '');
  if (digitos.length !== 8) return null;

  // Sem timeout, uma rede ruim deixa o campo "buscando…" para sempre.
  const controle = new AbortController();
  const limite = setTimeout(() => controle.abort(), 6000);

  try {
    const resposta = await fetch(`https://viacep.com.br/ws/${digitos}/json/`, { signal: controle.signal });
    if (!resposta.ok) return null;
    const dados = await resposta.json();
    // O ViaCEP responde 200 com `{ erro: true }` para CEP inexistente.
    if (dados.erro) return null;
    return {
      street: dados.logradouro || '',
      district: dados.bairro || '',
      city: dados.localidade || '',
      state: dados.uf || '',
    };
  } catch {
    return null;
  } finally {
    clearTimeout(limite);
  }
}

export function formatarCep(valor) {
  const d = (valor || '').replace(/\D/g, '').slice(0, 8);
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
}
